import { call, put, takeEvery } from "redux-saga/effects";

import { 
  GET_SETTINGS, 
  UPDATE_SETTING,

 } from "./actionTypes";
import {
  getSettingsSuccess,
  getSettingsFail,
  updateSettingSuccess,
  updateSettingFail,

} from "./actions";

import { 
  getSettings,
  updateSetting,
} from "../../helpers/backend_helper";
import { showPopup } from "../popup/actions";

function* fetchSettings() {
  try {
    const response = yield call(getSettings);
    yield put(getSettingsSuccess(response));
  } catch (error) {
    yield put(getSettingsFail(error));
  }
}

function* onUpdateSetting({ payload: { setting, history } }) {
  try {
   let response = yield call(updateSetting, setting);
    // yield put(updateSettingSuccess(setting));
    yield put(showPopup({title:response.message,success:true}));

  } catch (error) {
    yield put(updateSettingFail(error));
      yield put(showPopup({title:error.response.message,error:true}));

  }
}




function* settingsSaga() {
  yield takeEvery(GET_SETTINGS, fetchSettings);
  yield takeEvery(UPDATE_SETTING, onUpdateSetting);
}

export default settingsSaga;
